import { Lot } from '../../types';
import { TemplateComponent } from '../DocumentGenerator';
import { formatDecimal } from '../templates/formatters';

export type LotTemplateType = { grade?: string; quantity?: string; lotNumber: string };

export const LotComponent: TemplateComponent<Partial<Lot> | undefined, LotTemplateType, void, false> = {
  templatize: (lot) => ({
    toString: () => lot?.slug ?? '',
    lotNumber: lot?.slug ?? '',
    grade: lot?.grade,
    quantity: formatDecimal(lot?.quantity ?? 0),
  }),
  definitionMap: {
    lotNumber: { label: 'Lot Number', type: 'string' },
    grade: { label: 'Grade', type: 'string' },
    quantity: { label: 'Quantity', type: 'string' },
  },
};
